import { Select, SelectProps } from "@tfg/ui"
import { Dispatch, SetStateAction } from "react"
import { useTranslation } from "react-i18next"

import { filtersValidationType } from "@tfg/types/schemas/products"

type Props = SelectProps & {
  filtersValue: filtersValidationType
  setFiltersValue: Dispatch<SetStateAction<filtersValidationType>>
}

export const ProductIncomingLaunchDateFilter = ({
  setFiltersValue,
  filtersValue,
  ...props
}: Props) => {
  const { t } = useTranslation("products")

  return (
    <Select
      data={[
        { value: "incoming", label: t("lists.placeholders.incoming") },
        { value: "expired", label: t("lists.placeholders.expired") },
        { value: "all", label: t("lists.placeholders.allF") },
      ]}
      w={150}
      size="xs"
      clearable
      searchable
      onChange={(value: string | null) =>
        setFiltersValue({
          ...filtersValue,
          incomingLaunchDate:
            value === "incoming" || value === "expired" || value === "all"
              ? value
              : undefined,
        })
      }
      placeholder={t("lists.placeholders.launchDate")}
      value={filtersValue.incomingLaunchDate}
      {...props}
    />
  )
}
